export * from './cadastro-status-icon';
